import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { ROUTE_PATH } from '../../../../config/paths';
import RouteBasicInformationResource from './resource/RouteBasicInformationResource';
import { clearRoute, getRoute } from '../../../../actions';
import RouteToolbar from './RouteToolbar';

export const RouteView = ({
  breadcrumbs,
  dispatchGetRoute,
  dispatchClearRoute,
  match: {
    params: { id: routeId },
  },
  loading,
  route,
}) => {
  useLayoutEffect(() => {
    dispatchGetRoute({ routeId });

    return () => dispatchClearRoute();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (route.isEmpty())
    content = <NoDataResource returnPage={ROUTE_PATH} />;
  else {
    const routeJson = route.toJS();

    content = <RouteBasicInformationResource {...routeJson} />;

    toolbar = <RouteToolbar routeId={routeJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Ruta"
      content={content}
    />
  );
};

RouteView.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearRoute: PropTypes.func.isRequired,
  dispatchGetRoute: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  route: PropTypes.instanceOf(Immutable.Map).isRequired,
};

RouteView.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearRoute: clearRoute,
  dispatchGetRoute: getRoute,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Rutas',
      href: ROUTE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  route: RouteUnit.Route.getIn(['current', 'content']),
  loading: !RouteUnit.Route.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteView);
